export default "__VITE_ASSET__BXwaFeDM__"